import * as Sentry from '@sentry/browser'

/**
 * Какие ответы Api.request уходят в Sentry.
 * `statuses: 'all'` — всё, кроме `skip`.
 * Потом сузить, например: `statuses: [400, 422, 500]` и/или `skip: [499, 401]`.
 */
export const API_SENTRY_ERROR_LOG = {
  enabled: true,
  statuses: 'all',
  skip: [499],
}

const resolveStatus = (error) => {
  if (error?.message === 'Network Error') {
    return 'network'
  }

  if (error?.code === 'ECONNABORTED') {
    return 'timeout'
  }

  return error?.response?.status ?? 'unknown'
}

const shouldLogStatus = (status) => {
  const { enabled, statuses, skip } = API_SENTRY_ERROR_LOG

  if (!enabled) {
    return false
  }

  if (typeof status === 'number' && skip.includes(status)) {
    return false
  }

  if (statuses === 'all') {
    return true
  }

  return Array.isArray(statuses) && statuses.includes(status)
}

export const reportInvalidApiPathToSentry = ({ method, path, page, invalidSegment }) => {
  try {
    if (!Sentry.isInitialized()) {
      return
    }

    Sentry.withScope((scope) => {
      scope.setLevel('warning')
      scope.setTag('api.method', String(method || 'get').toUpperCase())
      scope.setTag('api.path', path)
      scope.setTag('api.invalid_segment', String(invalidSegment))
      scope.setTag('page', page)
      scope.setFingerprint(['invalid-api-path'])
      scope.setContext('api', {
        method,
        page,
        path,
        invalidSegment,
      })
      Sentry.captureMessage('API request with missing path param')
    })
  } catch {
    // reporting must never break the request pipeline
  }
}

export const reportApiErrorToSentry = (error) => {
  try {
    if (!Sentry.isInitialized()) {
      return
    }

    const status = resolveStatus(error)

    if (!shouldLogStatus(status)) {
      return
    }

    const config = error?.config || {}
    const method = String(config.method || 'get').toUpperCase()
    const apiPath = String(config.url || '').split('?')[0]
    const page = window.location.pathname
    const isClientError = typeof status === 'number' && status < 500

    Sentry.withScope((scope) => {
      scope.setLevel(isClientError ? 'warning' : 'error')
      scope.setTag('api.status', String(status))
      scope.setTag('api.method', method)
      scope.setTag('api.path', apiPath)
      scope.setTag('page', page)
      scope.setFingerprint(['api-request-failed'])
      scope.setContext('api', {
        method,
        page,
        path: apiPath,
        status,
      })
      Sentry.captureMessage('API request failed')
    })
  } catch {
    // reporting must never break the request pipeline
  }
}
